import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import mailIcon from '../../../assets/mail.svg';
import clockIcon from '../../../assets/reloj-de-pared.svg';
import phoneIcon from '../../../assets/smartphone.svg';
import { postSendOtp, postValidateOtp } from '../../../services/mentoriaService';
import authContext from '../../../shared/src/contexts/authContext';
import Button from '../../atoms/button/button';
import MentoriaIconTitle from '../icon-title/iconTitle';
import './otp.scss';

const DURATION = 1 //minutos

type TOtp = { 
	handleCorrectCode: any;
	handleGoBack: any;
}

const Otp = (props: TOtp) => {

	const [code, setCode] = useState('');
	const [timer, setTimer] = useState(DURATION * 60);
	const [countdown, setCountdown] = useState<any>(null);
	const [, setLoading] = useState(false);
	const Context = useContext(authContext);
	const email = Context?.gigyaAccount?.profile.email || "";
	const mobile = Context?.gigyaAccount?.data.mobile || "";
	const [filteredEmail, setFilteredEmail] = useState("");
	const [filteredMobile, setFilteredMobile] = useState("");
	const navigate = useNavigate();
	const [error, setError] = useState('');



	const registerOtp = async (option:number) =>{
		let service;
		switch (option) {
			case 1:
				service = { "cellPhone": mobile };
				break;
			case 2:
				service = { "email": email };
				break;
			default:
				service = {};
				break;
		}
		try {
			await postSendOtp(service).then(res => {
			if (res.data.status === 200) {
				setTimer(res.data.data.lifeToken * 60);
				setCountdown(setInterval(() => {
					setTimer(prev => prev - 1);
				}, 1000));
			} 
		})
		} catch (error) {
			setError('*Hubo un problema al generar el código OTP, intentalo nuevamente');
			setTimer(0);
			
		}

		
	};

	const checkOtp = async () => {
		setError('');
		if (code == null || code == "") {
			setError('*No ingresaste ningún código');
		} else {
			try {
				postValidateOtp( {
					cellPhone: mobile,
					codeOtp: code,
					email: email,
				}).then((res) => {
					if (res.data.status === 200) {
						props.handleCorrectCode();
						navigate("/formulario-inicial/tratamiento-datos/listo");
					} else {
						setError('*El código que acabas de ingresar es incorrecto, verifica')
					}
				});
			} catch (error) {
				setError('Hubo un error validando el código, intentalo nuevamente');
			}
		}
	};

	useEffect(() => {
		if (mobile) setFilteredMobile(mobile.substring(0, 3) + '*'.repeat(6) + mobile.substring(9, 11));
		if (email) setFilteredEmail(email.substring(0, 2) + '*'.repeat(email.split('@')[0].length) + '@' + email.split('@')[1]);
		setLoading(true);
		return (() => {
			clearInterval(countdown)
		});
	}, []);

	useEffect(() => {
		if (timer <= 0) {
			clearInterval(countdown);
			setTimer(0);
		}
	}, [timer]);

	return (
		<div className="mentoria-otp">
			<header className="mentoria-otp__header">
				<h1 className="mentoria-otp__header__title">Autorización de tratamiento de datos</h1>
				<h2 className="mentoria-otp__header__subtitle">Para aceptar el tratamiento de tus datos, elige si prefieres recibir un código en tu WhatsApp o en tu correo electrónico.</h2>
				<section className="mentoria-otp__header__section">
					<div className="mentoria-otp__header__section__card-body">
					{filteredMobile && (
						<div className="mentoria-otp__header__section__card">
							<input type="radio" name="contactMethod" value="1" />
							<img className="mentoria-otp__header__section__card__img" src={phoneIcon} alt="Número de celular" />
							<div className="mentoria-otp__header__section__card__container">
								<p className="mentoria-otp__header__section__card__title">Número de celular</p>
								<p className="mentoria-otp__header__section__card__subtitle">{filteredMobile}</p>
							</div>
						</div>
					)}
					{filteredEmail && (
						<div className="mentoria-otp__header__section__card">
							<input type="radio" name="contactMethod" value="2" />
							<img className="mentoria-otp__header__section__card__img" src={mailIcon} alt="Correo electrónico" />
							<div>
								<p className="mentoria-otp__header__section__card__title">Correo electrónico</p>
								<p className="mentoria-otp__header__section__card__subtitle">{filteredEmail}</p>
							</div>
						</div>
					)}
					</div>
					<div className="mentoria-otp__header__section__card">
						<Button text="Enviar código" gtmClass='primary' type="button"
							onClick={(e) => { 
								e.preventDefault(); 
								const selectedMethod = (document.querySelector('input[name="contactMethod"]:checked') as HTMLInputElement)?.value;
								if (!selectedMethod) {
									setError('*Por favor selecciona un método de contacto');
									return;
								}
								registerOtp(parseInt(selectedMethod));
						}}/>
					</div>
				</section>
			</header>
			<main className="mentoria-otp__main">
				<p className="mentoria-otp__main__title">Una vez recibido ingrésalo en el siguiente campo</p>
				<input type='password' value={code} onChange={(e) => setCode(e.target.value)} className="mentoria-otp__main__input" placeholder='Digita el código' />
				{error && <p className='mentoria-otp__main__error'>{error}</p>}
				<MentoriaIconTitle width={21} text={`Reenviar código en ${Math.floor(timer / 60) + ':' + (timer % 60 < 10 ? '0' : '') + Math.round(timer % 60)} minutos`} src={clockIcon} />
			</main>
			<div className="mentoria-otp__buttons">
				<Button text="Validar código" gtmClass='secondary' disabled={false} type="button" onClick={checkOtp} />
			</div>
		</div>
	)
}

export default Otp